/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version: 1.3.6
 *
 */
;(function(e) {
  e.fn.extend({
    slimScroll: function(g) {
      var a = e.extend(
        {
          width: 'auto',
          height: '250px',
          size: '7px',
          color: '#000',
          position: 'right',
          distance: '1px',
          start: 'top',
          opacity: 0.4,
          alwaysVisible: !1,
          disableFadeOut: !1,
          railVisible: !1,
          railColor: '#333',
          railOpacity: 0.2,
          railDraggable: !0,
          railClass: 'slimScrollRail',
          barClass: 'slimScrollBar',
          wrapperClass: 'slimScrollDiv',
          allowPageScroll: !1,
          wheelStep: 20,
          touchScrollStep: 200,
          borderRadius: '7px',
          railBorderRadius: '7px',
        },
        g
      )
      this.each(function() {
        function v(d) {
          if (r) {
            d = d || window.event
            var c = 0
            d.wheelDelta && (c = -d.wheelDelta / 120)
            d.detail && (c = d.detail / 3)
            e(d.target || d.srcTarget || d.srcElement)
              .closest('.' + a.wrapperClass)
              .is(b.parent()) && m(c, !0)
            d.preventDefault && !k && d.preventDefault()
            k || (d.returnValue = !1)
          }
        }
        function m(d, e, g) {
          k = !1
          var f = d,
            h = b.outerHeight() - c.outerHeight()
          e &&
            ((f =
              parseInt(c.css('top')) +
              ((d * parseInt(a.wheelStep)) / 100) * c.outerHeight()),
            (f = Math.min(Math.max(f, 0), h)),
            (f = 0 < d ? Math.ceil(f) : Math.floor(f)),
            c.css({ top: f + 'px' }))
          l = parseInt(c.css('top')) / (b.outerHeight() - c.outerHeight())
          f = l * (b[0].scrollHeight - b.outerHeight())
          g &&
            ((f = d),
            (d = (f / b[0].scrollHeight) * b.outerHeight()),
            (d = Math.min(Math.max(d, 0), h)),
            c.css({ top: d + 'px' }))
          b.scrollTop(f)
          b.trigger('slimscrolling', ~~f)
          w()
          p()
        }
        function x() {
          u = Math.max(
            (b.outerHeight() / b[0].scrollHeight) * b.outerHeight(),
            30
          )
          c.css({ height: u + 'px' })
          var a = u == b.outerHeight() ? 'none' : 'block'
          c.css({ display: a })
        }
        function w() {
          x()
          clearTimeout(B)
          l == ~~l
            ? ((k = a.allowPageScroll),
              C != l && b.trigger('slimscroll', 0 == ~~l ? 'top' : 'bottom'))
            : (k = !1)
          C = l
          u >= b.outerHeight()
            ? (k = !0)
            : (c.stop(!0, !0).fadeIn('fast'),
              a.railVisible && h.stop(!0, !0).fadeIn('fast'))
        }
        function p() {
          a.alwaysVisible ||
            (B = setTimeout(function() {
              ;(a.disableFadeOut && r) ||
                y ||
                z ||
                (c.fadeOut('slow'), h.fadeOut('slow'))
            }, 1e3))
        }
        var r,
          y,
          z,
          B,
          A,
          u,
          l,
          C,
          k = !1,
          b = e(this)
        if (b.parent().hasClass(a.wrapperClass)) {
          var n = b.scrollTop(),
            c = b.closest('.' + a.barClass),
            h = b.closest('.' + a.railClass)
          x()
          if (e.isPlainObject(g)) {
            if ('height' in g && 'auto' == g.height) {
              b.parent().css('height', 'auto')
              b.css('height', 'auto')
              var q = b
                .parent()
                .parent()
                .height()
              b.parent().css('height', q)
              b.css('height', q)
            }
            if ('scrollTo' in g) n = parseInt(a.scrollTo)
            else if ('scrollBy' in g) n += parseInt(a.scrollBy)
            else if ('destroy' in g) {
              c.remove()
              h.remove()
              b.unwrap()
              return
            }
            m(n, !1, !0)
          }
        } else if (!(e.isPlainObject(g) && 'destroy' in g)) {
          a.height = 'auto' == a.height ? b.parent().height() : a.height
          n = e('<div></div>')
            .addClass(a.wrapperClass)
            .css({
              position: 'relative',
              overflow: 'hidden',
              width: a.width,
              height: a.height,
            })
          b.css({ overflow: 'hidden', width: a.width, height: a.height })
          var h = e('<div></div>')
              .addClass(a.railClass)
              .css({
                width: a.size,
                height: '100%',
                position: 'absolute',
                top: 0,
                display: a.alwaysVisible && a.railVisible ? 'block' : 'none',
                'border-radius': a.railBorderRadius,
                background: a.railColor,
                opacity: a.railOpacity,
                zIndex: 90,
              }),
            c = e('<div></div>')
              .addClass(a.barClass)
              .css({
                background: a.color,
                width: a.size,
                position: 'absolute',
                top: 0,
                opacity: a.opacity,
                display: a.alwaysVisible ? 'block' : 'none',
                'border-radius': a.borderRadius,
                BorderRadius: a.borderRadius,
                MozBorderRadius: a.borderRadius,
                WebkitBorderRadius: a.borderRadius,
                zIndex: 99,
              }),
            q =
              'right' == a.position
                ? { right: a.distance }
                : { left: a.distance }
          h.css(q)
          c.css(q)
          b.wrap(n)
          b.parent().append(c)
          b.parent().append(h)
          a.railDraggable &&
            c
              .bind('mousedown', function(a) {
                var b = e(document)
                z = !0
                t = parseFloat(c.css('top'))
                pageY = a.pageY
                b.bind('mousemove.slimscroll', function(a) {
                  currTop = t + a.pageY - pageY
                  c.css('top', currTop)
                  m(0, c.position().top, !1)
                })
                b.bind('mouseup.slimscroll', function(a) {
                  z = !1
                  p()
                  b.unbind('.slimscroll')
                })
                return !1
              })
              .bind('selectstart.slimscroll', function(a) {
                a.stopPropagation()
                a.preventDefault()
                return !1
              })
          h.hover(
            function() {
              w()
            },
            function() {
              p()
            }
          )
          c.hover(
            function() {
              y = !0
            },
            function() {
              y = !1
            }
          )
          b.hover(
            function() {
              r = !0
              w()
              p()
            },
            function() {
              r = !1
              p()
            }
          )
          b.bind('touchstart', function(a, b) {
            a.originalEvent.touches.length &&
              (A = a.originalEvent.touches[0].pageY)
          })
          b.bind('touchmove', function(b) {
            k || b.originalEvent.preventDefault()
            b.originalEvent.touches.length &&
              (m(
                (A - b.originalEvent.touches[0].pageY) / a.touchScrollStep,
                !0
              ),
              (A = b.originalEvent.touches[0].pageY))
          })
          x()
          'bottom' === a.start
            ? (c.css({ top: b.outerHeight() - c.outerHeight() }), m(0, !0))
            : 'top' !== a.start &&
              (m(e(a.start).position().top, null, !0),
              a.alwaysVisible || c.hide())
          window.addEventListener
            ? (this.addEventListener('DOMMouseScroll', v, !1),
              this.addEventListener('mousewheel', v, !1))
            : document.attachEvent('onmousewheel', v)
        }
      })
      return this
    },
  })
  e.fn.extend({ slimscroll: e.fn.slimScroll })
})(jQuery)
